export default function TruckIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 .6 56 44.2">
            <path fill="#EE8A22" d="M39.8 36.5h-38v-34h37.8l.2 34Z"/>
            <path fill="#53575A" d="M39.2 35.9H0V.6h39l.2 35.3Zm-38-1.2H38l-.1-32.9H1.2v32.9Z"/>
            <path fill="#fff" d="M12.4 44.8c3 0 5.4-2.4 5.4-5.4a5.5 5.5 0 0 0-10.9 0c0 3 2.4 5.4 5.5 5.4Z"/>
            <path fill="#53575A" d="M11.1 44.2a6 6 0 0 1-6-6 6 6 0 0 1 6-6 6 6 0 0 1 6.1 6 6 6 0 0 1-6 6Zm0-10.8a4.8 4.8 0 0 0-4.8 4.8c0 2.6 2.1 4.7 4.8 4.7 2.7 0 4.9-2 4.9-4.7 0-2.6-2.2-4.8-4.9-4.8Z"/>
            <path fill="#fff" d="M5.7 26.4H1.9v3.8h3.8v-3.8Z"/>
            <path fill="#53575A" d="M5 29.6H0v-5h5v5Zm-3.8-1.2h2.6v-2.6H1.2v2.6Z"/>
            <path fill="#53575A" d="M34.5 23H18v1h16.4v-1Z"/>
            <path fill="#53575A" d="M34.5 26.5h-5.8v1.2h5.8v-1.2Z"/>
            <path fill="#53575A" d="M12.4 37.6H10v1.2h2.4v-1.2Z"/>
            <path fill="#fff" d="M43.7 19.2h8.6l-4.6-6.6h-7.9v23.9H56v-9.7H43.7v-7.6Z"/>
            <path fill="#53575A" d="M55.4 35.9H37.9V10.8h9l5.3 7.8h-9V25h12.2v10.9Zm-16.2-1.2h15v-8.5H41.8v-8.8h8L46.2 12h-7v22.7Z"/>
            <path fill="#EE8A22" d="M52.3 19.2h-8.6v7.6H56v-2l-3.7-5.6Z"/>
            <path fill="#53575A" d="M55.4 26.2H41.9v-8.8h9.5l4 6v2.8ZM43 25h11v-1.3l-3.4-5H43V25Z"/>
            <path fill="#53575A" d="M43.1 25.6H42v4.1h1v-4.1Z"/>
            <path fill="#fff" d="M48.1 44.8c3 0 5.5-2.4 5.5-5.4 0-3-2.5-5.4-5.5-5.4s-5.5 2.4-5.5 5.4c0 3 2.5 5.4 5.5 5.4Z"/>
            <path fill="#53575A" d="M46.9 44.2a6 6 0 0 1-6.1-6 6 6 0 0 1 6-6 6 6 0 0 1 6.2 6 6 6 0 0 1-6.1 6Zm0-10.8a4.8 4.8 0 0 0-4.9 4.8c0 2.6 2.2 4.7 4.9 4.7s4.8-2 4.8-4.7c0-2.6-2.1-4.8-4.8-4.8Z"/>
            <path fill="#53575A" d="M48 37.6h-2.3v1.2H48v-1.2Z"/>
        </svg>
    )
}